import { storyEditSchema } from '../../StoryEdit/story-edit.saga';
import { take, call, put } from 'redux-saga/effects';
import { createStory, redirectToCreateStory } from './stories.actions';
import { callApi } from '../../api';
import { storyCreateCallOptions } from '../../../services/story.services';
import { InitialStory } from '../../../modules/StoryCreate/index';
import {
  editStoryFetched,
  saveStory,
  updateStoryEditSettings,
  resetActiveStory,
  startLoading,
  stopLoading,
} from '../../StoryEdit/story-edit.actions';
import { normalize } from 'normalizr';
import { push } from 'react-router-redux';
import * as R from 'ramda';

function* postNewStory(initialStory: InitialStory) {
  const createCallOptions = storyCreateCallOptions(initialStory);
  const { clusters, selectedClusters } = initialStory;

  yield put(startLoading());

  const data = yield call(callApi, createCallOptions);
  if (!data.ok) {
    return false;
  }

  const {
    entities: { story, appConfigs },
  } = normalize(data.data, storyEditSchema);
  const {
    data: { id },
  } = data;

  yield put(
    editStoryFetched({
      story: {
        ...story[id],
        clusters,
      },
      appConfigs,
      cluster: R.indexBy(R.prop('id'), selectedClusters || []),
    })
  );

  yield put(saveStory());

  yield put(stopLoading());

  yield put(push(`/stories/${id}/edit`));
}

export function* watchForStoryCreate() {
  while (true) {
    const {
      payload,
      payload: { id: storyId },
    } = yield take(createStory.type);

    if (storyId) {
      yield put(updateStoryEditSettings(payload));
      yield put(saveStory());
      yield put(push(`/stories/${storyId}/edit`));
    } else {
      yield postNewStory(payload);
    }
  }
}

export function* watchRedirectToCreate() {
  while (true) {
    yield take(redirectToCreateStory.type);
    yield put(resetActiveStory());
    yield put(push('/stories/settings'));
  }
}



// WEBPACK FOOTER //
// ./src/store/Entities/Stories/stories.saga.ts